import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { SearchParams } from '@interfaces/search-params.model';
import { AppParamsService } from '../app.params.service';
import { TranslateService } from '@ngx-translate/core';
import { UUID } from 'angular2-uuid';
import { SearchSummary } from '@interfaces/search-summary.interface';
import { MemberParams } from '@interfaces/member-params.model';
import { catchError, map } from 'rxjs/operators';
import { ConfigurationService } from '@services/configuration.service';
import { clone, extend, identity, pickBy } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class SearchSummaryService {
  constructor(
    private http: HttpClient,
    private appParams: AppParamsService,
    private translate: TranslateService,
    private configurationService: ConfigurationService
  ) {}

  /**
   * Get search summary
   * @param params: SearchParams
   * @returns Observable<SearchSummary>
   */
  public getSearchSummary(params: SearchParams): Observable<SearchSummary> {
    return this.requestSearchSummary(params);
  }

  private requestSearchSummary(
    params: SearchParams
  ): Observable<SearchSummary> {
    return this.http
      .get('/api/providers/summary.json', {
        params: this.getHttpRequestParams(params),
        withCredentials: true,
      })
      .pipe(
        catchError(() =>
          of({
            _meta: { cache_status: 'complete' },
            providers: [],
          })
        ),
        map((data: SearchSummary) => data || null)
      );
  }

  private getHttpRequestParams(params: SearchParams): HttpParams {
    params = clone(params);
    // Add member params
    extend(params, this.getMemberParams());
    // Add locale
    params.locale = this.getLocale();
    // Add transaction id
    params.transaction_id = UUID.UUID();
    // Add account id
    params.account_id = this.configurationService.account_id.getValue();
    // Instantiate new params class
    params = new SearchParams(params);
    // Get truthy params only
    params = pickBy(params, identity);
    // Generate and return HttpParams object
    return new HttpParams({ fromObject: params as any });
  }

  private getMemberParams(): MemberParams {
    let params = this.appParams.getMemberParams();
    params = new MemberParams(params);
    return params;
  }

  private getLocale(): string {
    let lang = 'en';
    if (this.translate && this.translate.currentLang) {
      lang = this.translate.currentLang;
    }
    return `${lang}`;
  }
}
